import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import useDialect from '../hooks/useDialect';
import { SamuelLab } from '../components/samuel/SamuelLab';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const abs = (u) => (u && !u.startsWith('http') ? `${BACKEND_URL}${u}` : u);

// Steve's recordings for a card, in the current dialect.
export const steveClipsOf = (phoneme, dialect) => {
  if (!phoneme) return [];
  const a = phoneme.audio?.[dialect] || phoneme.audio?.AmE || {};
  const out = [];
  if (a.isolated) out.push({ label: `/${phoneme.ipa}/`, url: abs(a.isolated) });
  (a.examples || []).forEach((u, i) => u && out.push({ label: `Frase ${i + 1}`, url: abs(u) }));
  return out;
};

export default function VocalLabPage() {
  const { dialect, setDialect } = useDialect();
  const [card, setCard] = useState(null);
  useEffect(() => {
    fetch(`${BACKEND_URL}/api/phonemes/u-foot`).then((r) => (r.ok ? r.json() : null)).then(setCard).catch(() => setCard(null));
  }, []);
  const words = (card?.examples || []).map((e) => (typeof e === 'string' ? e : e?.text)).filter(Boolean);
  return (
    <div className="min-h-screen bg-[#030712] text-white" data-testid="vocal-lab-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 space-y-8">
        <Link to="/lms/phonemes" className="inline-flex items-center gap-2 text-sm text-cyan-300 hover:text-white" data-testid="vocal-lab-back"><ArrowLeft className="w-4 h-4" /> Libreria fonetica</Link>
        <div className="max-w-3xl space-y-3">
          <p className="text-[11px] uppercase tracking-[0.3em] text-amber-400 font-bold">VocalFitness Lab</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">Una bocca che impara a parlare come te.</h1>
          <p className="text-base text-slate-300">Parla, scegli una registrazione di Steve o scrivi una frase: la rete neurale Samuel muove lingua, labbra e glottide per imitarla.
            Poi passa alla modalità <span className="text-amber-300 font-semibold">VocalFitness</span> per vedere l’articolazione foneticamente corretta, fonema per fonema, sul trapezio e sullo spettrogramma.</p>
          <div className="flex gap-1 rounded-full bg-slate-900 border border-cyan-500/20 p-1 w-fit" data-testid="vocal-lab-dialect">
            {[['AmE', 'General American'], ['RP', 'British RP']].map(([k, l]) => (
              <button key={k} onClick={() => setDialect(k)} data-testid={`vocal-lab-dialect-${k}`} className={`px-4 py-1.5 rounded-full text-xs font-bold ${dialect === k ? 'bg-cyan-400 text-slate-950' : 'text-cyan-100'}`}>{l}</button>
            ))}
          </div>
        </div>
        <SamuelLab dialect={dialect} words={words} steveClips={steveClipsOf(card, dialect)} />
      </div>
    </div>
  );
}
